import { Badge, BadgeGroup, BadgeProps } from '@synqo/frontend-component-library';

interface BadgesProps {
    badges: BadgeProps[];
}

export function Badges({ badges }: BadgesProps) {
    return (
        <BadgeGroup>
            {badges.map((p, index) => (
                <Badge {...p} key={index} />
            ))}
        </BadgeGroup>
    );
}
